import clsx from "clsx";

function TableTotalsRow({ children, hidden = false }) {
  return (
    // Tidak sticky: TableWrapper punya pb-24, sehingga baris sticky bottom-0
    // menempel 96px di atas dasar area scroll dan tampak melayang di tengah.
    <tr
      className={clsx(
        "transition-colors ease-in-out duration-300",
        hidden
          ? "bg-gray-200 dark:bg-gray-600"
          : "dark:hover:bg-gray-900 hover:bg-gray-50"
      )}
    >
      {children}
    </tr>
  );
}

export default TableTotalsRow;
